module.exports = function(service) {
	'use strict'
	service.factory('downloadPdf',downloadPdf);
	downloadPdf.$inject=['authtokenService','$timeout'];
	function downloadPdf(authtokenService,$timeout) {
        return function(approval) {
            var token = authtokenService.getToken();
            var getPdfFunction = function() {
                if(!approval.url) return
                var req = new XMLHttpRequest();
                var filename = (approval.title)? slugify(approval.title) + '.pdf':'approval.pdf';
                req.open("GET", approval.url, true);
                req.setRequestHeader('x-auth', token)
                req.responseType = "blob";
                req.onload = function (event) {
                    var blob = req.response;
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    link.style = "display: none";
                document.body.appendChild(link);  
                    link.download=filename;
                    link.click();
                    $timeout(function(){
                        document.body.removeChild(link);
                    },0)
                };
                req.send();
            }
            getPdfFunction();
        }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/downloadPdfService.js
// module id = 597
// module chunks = 0